import { useDispatch as useDispatchWithoutTypes } from 'react-redux';
import { AppDispatch } from '~/store';

export const useDispatch = useDispatchWithoutTypes.withTypes<AppDispatch>();
